import Reveal from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Punctuality is respect.",
    body: "Your driver is staged and waiting before your appointed time — flight-tracked for every airport pickup, no exceptions.",
  },
  {
    n: "02",
    title: "Discretion by default.",
    body: "Executives, families and private clients ride with us for one reason: what happens in the cabin stays in the cabin.",
  },
  {
    n: "03",
    title: "One driver. One standard.",
    body: "No dispatch roulette. Owner-operated black car service where the person behind the wheel answers your call.",
  },
];

export const Manifesto = () => (
  <section id="ethos" className="border-y border-white/10 bg-[#080808]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
      <Reveal>
        <p className="overline mb-5">02 — The Ethos</p>
        <h2 className="font-serif text-4xl lg:text-6xl tracking-tight max-w-3xl leading-tight">
          A car service measured in trust, not miles.
        </h2>
      </Reveal>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.15} className="relative">
            <span className="font-serif text-8xl text-white/[0.07] absolute -top-10 -left-2 select-none">
              {c.n}
            </span>
            <div className="relative pt-6 border-t border-gold/40 max-w-xs">
              <h3 className="font-serif text-2xl lg:text-3xl mb-4">{c.title}</h3>
              <p className="text-[#8A8A8A] font-light leading-relaxed">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
